import React, { useEffect } from 'react';
import Header from './Header/Header';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import "./MainMaster.css";
import Footer from './Footer/Footer';
import { isMobile } from 'react-device-detect';
import DesktopFooter from './Footer/DesktopFooter/Footer';
import { Capacitor } from '@capacitor/core';
const MainMaster = () => {
    const navigate = useNavigate();
    const location = useLocation();
  
    useEffect(() => {
      const isApp = Capacitor.isNativePlatform();
      if (isApp && location.pathname === '/') {
        navigate('/login', { replace: true });
      }
    }, []);
    
  return (
    <>
        <section className="home-main-area">
        <Header></Header>
        <Outlet></Outlet>
        {isMobile ?  <Footer /> :  <DesktopFooter />}
       
      </section>
    </>
  );
};

export default MainMaster;